/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerDetailResult } from '../models/CustomerDetailResult';
import type { GetCustomerDetailRequest } from '../models/GetCustomerDetailRequest';
import type { ListProductsResult } from '../models/ListProductsResult';
import type { ProcessTransactionCommandResult } from '../models/ProcessTransactionCommandResult';
import type { ProcessTransactionRequest } from '../models/ProcessTransactionRequest';
import type { PurchaseDto } from '../models/PurchaseDto';
import type { ResendHuurayGiftCardRequest } from '../models/ResendHuurayGiftCardRequest';
import type { RetryProvisioningHuurayGiftCardRequest } from '../models/RetryProvisioningHuurayGiftCardRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WebshopService {
    /**
     * @returns ListProductsResult Success
     * @throws ApiError
     */
    public static postApiWebshopListProducts(): CancelablePromise<ListProductsResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/webshop/list-products',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @returns PurchaseDto Success
     * @throws ApiError
     */
    public static postApiWebshopListPurchaseHistory(): CancelablePromise<Array<PurchaseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/webshop/list-purchase-history',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param xApiKey
     * @param requestBody
     * @returns CustomerDetailResult Success
     * @throws ApiError
     */
    public static postApiWebshopGetCustomerDetail(
        xApiKey?: string,
        requestBody?: GetCustomerDetailRequest,
    ): CancelablePromise<CustomerDetailResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/webshop/get-customer-detail',
            headers: {
                'x-api-key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param xApiKey
     * @param requestBody
     * @returns ProcessTransactionCommandResult Success
     * @throws ApiError
     */
    public static postApiWebshopProcessTransaction(
        xApiKey?: string,
        requestBody?: ProcessTransactionRequest,
    ): CancelablePromise<ProcessTransactionCommandResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/webshop/process-transaction',
            headers: {
                'x-api-key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiWebshopRetryProvisioningHuurayGiftCard(
        requestBody?: RetryProvisioningHuurayGiftCardRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/webshop/retry-provisioning-huuray-gift-card',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiWebshopResendHuurayGiftCard(
        requestBody?: ResendHuurayGiftCardRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/webshop/resend-huuray-gift-card',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
}
